import { useSelector } from 'react-redux';
import { selectUserInfo } from 'store/slices/userInfoSlice';
import ProductCreateForm from './product-create-form';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { Card } from 'antd';

const ProductCreatePageV2 = () => {
  const { userId: adminId } = useSelector(selectUserInfo);

  if (!adminId) {
    return null;
  }

  return (
    <Card title={i18n.t(LOCALS.product_add)} bodyStyle={{ padding: '16px' }}>
      <ProductCreateForm
        disabledCostPrice={false}
        disabledCareCost={false}
        minCostPrice={0}
        canEditSourceType={true}
        viewMode={false}
      />
    </Card>
  );
};

export default ProductCreatePageV2;
